<template>
    <div class="smoke">
        <div class="headle">
            <div class="banner_img">
                <img src="@/assets/img/banner.png" alt="">
            </div>
            <div class="navigation">
                <div class="nearby bg" style="background-position-x: 30px;" @click="showAddressVisible()">地区选择</div>
                <div class="nearby bg" style="background-position-x: 30px;" @click="show=true">筛选</div>
                <div class="nearby bg"  @click="sortClick()">智能排序</div>
            </div>
        </div>
        <mt-loadmore :bottom-method="getSimDistributRecordHandler" :bottom-all-loaded="allLoaded"  :auto-fill="false" ref="loadmore">
            <div class="content" v-for="item in records" :key="item.id"  @click="linkMap(item)">
                <div class="data_item">
                    <div class="title">
						<span class="min-title">{{item.storeTypeName}}</span>
						<span class="max-title">{{item.name}}</span>
					</div>
					<div class="address">{{item.addressInfo}}</div>
					<div class="distance">
						<span class="distance_number">{{rice(item.dis)}}km</span>
						<span class="distance_btn" @click.stop="contact(item.id)">联系门店</span>
					</div>
					<div class="label">
						<span class="label-tabs" v-for="(el,index) in item.moveNames" :key="index">{{el.moveName}}</span>
					</div>
                </div>
            </div>
        </mt-loadmore>
         <!--  地区选择  -->
        <van-popup v-model="addressVisible" position="bottom">
            <van-area
                :area-list="areaList"
                :columns-placeholder="['请选择', '请选择', '请选择']"
                @cancel="cancelSelectAddress()"
                @confirm="selectAddress"
            />
        </van-popup>
         <!--  智能排序  -->
         <van-popup v-model="addressVisible1" position="bottom">
            <van-picker show-toolbar title="请选择" :columns="columns" 
            @cancel="cancelSelectAddress1()"
            @confirm="onConfirm"/>
        </van-popup>
        <!--刷选-->
        <van-popup v-model="show" position="right" :style="{ height: '100%',width: '50%' }">
            <div class="popupTitle">筛选</div>
            <div class="min-title">门店类型</div>
            <van-radio-group v-model="storeType">
                <van-radio :name="item.id" v-for="(item,index) in storeTypeList" :key="index">{{item.label}}</van-radio>
            </van-radio-group>
            <div class="min-title">热门活动</div>
            <van-checkbox-group v-model="moveIds">
                <van-checkbox shape="square" :name="item.id" v-for="(item,index) in moveIdList" :key="index">{{item.moveName}}</van-checkbox>
            </van-checkbox-group>
            <van-button type="info" size="small" @click="sumbit()">确认</van-button>
            <van-button type="default" size="small" @click="restSearch()">取消</van-button>
        </van-popup>
        <!--电话联系-->
        <div class="diagonIsshow" v-if="phoneShow">
            <div class="bg"></div>
            <div class="content">
                <div class="close"><img src="@/assets/img/close.png" alt="" srcset="" @click="phoneShow=false"></div>
                <div class="diagon-img"><img src="@/assets/img/phone.png" alt="" srcset=""></div>
                <div class="privacy">畅刻为保护双方隐私安全号码已做加密处理</div>
                <div class="phone">{{mobile}}</div>
                <a class="link_btn" :href="'tel:' + mobile">立即呼叫</a>
                <div class="ascription">号码归属地可能在全国任一城市，不影响接通</div>
            </div>
        </div>
    </div>
</template>
<script>
import { wxRequest} from '@/api/agent.js'
import areaListData from "@/utils/Area.js";
import { Toast } from 'vant'
export default {
    data(){
        return{
            records: [],
            pageNo: 0,
            addressVisible: false,
            addressVisible1:false,
            columns:[{text:'智能排序',value:''},{text:'距离排序',value:'22'}],
            storeTypeList:[{label:'授权店',id:0},{label:'专卖店',id:1}],
            perPageNum: 10,
            allPage: 0,
            allLoaded: false,
            show:false,
            addressTmp:'',
            phoneShow:false,
            moveIds:[],
            storeType:null,
            orderByLimit:'',
            moveIdList:[],
            longitude:'',
            latitude:'',
            mobile:'',
            areaList:areaListData
        }
    },
    created(){
        //获取当前位置的经纬度
        var data = {
            key: "UXXBZ-76EKJ-4UQFK-FXEPJ-CJB72-LUFK5" //key
        };
        var url = "https://apis.map.qq.com/ws/location/v1/ip"; //地理位置信息的接口
        data.output = "jsonp";
        this.$jsonp(url, data).then(res => {
            this.longitude=res.result.location.lng
            this.latitude=res.result.location.lat
            this.getSimDistributRecordHandler();
        }).catch(error => {
            console.log(error,456);
        })
        //初始化获取店铺活动
        wxRequest("/xxtx/wx/smoke/search/list", {}, "post").then(res => { 
            if(res.data.code == '200'){
                this.moveIdList = res.data.data     
            }
        })
    },
    methods:{
        //初始化数据
        getSimDistributRecordHandler(){
            this.pageNo += 1;
            var data = {
                pageNo: this.pageNo,
                moveIds:this.moveIds,
                longitude:this.longitude,
                latitude:this.latitude,
                address:this.addressTmp,
                storeType:this.storeType,
                orderByLimit:this.orderByLimit,
                perPageNum: this.perPageNum
            }
            wxRequest("/xxtx/wx/smoke/list", data, "post").then(res => { 
                if(res.data.code == 200){
                    this.allPage = Math.ceil(res.data.data.totalNum / this.perPageNum)
                    if(this.pageNo == this.allPage){
                        this.allLoaded = true;
                    }
                    this.records = this.records.concat(res.data.data.resultList)
                    this.$refs.loadmore.onBottomLoaded();    
                    this.$nextTick(function(){
                      //  window.scroll(0,0);
                    })                    
                }else{
                    Toast.fail( res.data.message);
                }
            })
        },
        // 联系门店
        contact(id){
            wxRequest("/xxtx/wx/smoke/search/phone/list", {id:id}, "post").then(res => { 
                if(res.data.code == 200){
                   this.mobile = res.data.data
                    this.phoneShow = true                
                }
            })
        },
        cancelSelectAddress() {
            this.addressTmp = "";
            this.addressVisible = false;
        },
        showAddressVisible() {
            this.addressVisible = true;
        },
        sortClick(){
            this.addressVisible1 = true;
        },
        cancelSelectAddress1(){
            this.orderByLimit=''
            this.addressVisible1 = false;
        },
        onConfirm(e){
            this.orderByLimit=e.value
            this.pageNo = 0   
            this.records=[]          
            this.getSimDistributRecordHandler(); 
            this.addressVisible1 = false;
        },
        sumbit(){
            this.pageNo = 0   
            this.records=[]          
            this.getSimDistributRecordHandler(); 
            this.moveIds=[]
            this.storeType=[]
            this.show = false;
        },
        restSearch(){
            this.show = false;
        },
        rice(data){
            return (data / 1000).toFixed(2)
        },
        selectAddress(values) {
            if (!values[0].code || values[0].code.length < 1) {
                Toast.fail("请选择地区");
                return;
            }

            if (!values[1].code || values[1].code.length < 1) {
                Toast.fail("请选择地区");
                return;
            }

            if (!values[2].code || values[2].code.length < 1) {
                Toast.fail("请选择地区");
                return;
            }

            if (
                values[0].code == "110000" ||
                values[0].code == "120000" ||
                values[0].code == "310000" ||
                values[0].code == "500000"
            ) {
                this.addressTmp = values[0].name + values[2].name;
            } else {
                this.addressTmp = values[0].name + values[1].name + values[2].name;
            }
            this.pageNo = 0
            this.records=[]
            this.getSimDistributRecordHandler()
            this.addressVisible = false;
        },
        linkMap(data){
            this.$router.push({ path: "/smoke/details", query: {id:data.id, longitude:this.longitude,latitude:this.latitude} });
        },
    }
}
</script>
<style lang="less" scoped>
.smoke{
    min-height:100vh;
    width:100%;
    background: #F7F7F7;
    .headle{
        padding:14px;
        background:#fff;
        padding-bottom: 0;
        .banner_img{
            width: 347px;
            height: 124px;
            img{
                height:100%;
                width:100%;
            }
        }
        .navigation{
            height:60px;
            line-height: 60px;
            display: flex;
            .nearby{
                width:13%;
                text-align: left;
                color: #2D2D2D;
                font-size:14px;
            }
            .bg{
                width: 29%;
                background: url('../../assets/img/arrom.png') no-repeat 58px center;
                background-size: 12px 7px;
            }
        }
    }
    .content{
        margin-top:14px;
        background:#fff;
        padding:20px 15px;
        margin-left: 14px;
        margin-right: 14px;
        .title{
            border-bottom: #EFEFEF 1px solid;
            padding-bottom: 21px;
            .min-title{
                display: inline-block;
                border:1px solid #CD6262;
                background: #FFF1F1;
                border-radius:3px;
                font-size:12px;
                color:#CD6262;
                padding:6px 8px;
                margin-right:7px;
            }
            .max-title{
                font-size:16px;
                color:#2D2D2D;
            }
        }
        .address{
            margin-top: 5px;
            font-size: 14px;
            color: #767676;
            line-height:20px;
            padding-left:25px;
            background: url('../../assets/img/icon2.png')no-repeat left center;
            background-size:14px 20px ;
        }
        .distance{
            margin-left:25px;
            margin-top:14px;
            .distance_number{
                display: inline-block;
                padding-left: 20px;
                color: #007AFF;
                font-size:14px;
                background: url('../../assets/img/icon1.png')no-repeat left center;
                background-size:12px 11px ;
            }
            .distance_btn{
                padding:6px 12px;
                background: #007AFF;
                border-radius:2px;
                cursor: pointer;
                color: #fff;
                float: right;
                font-size: 14px;
            }
        }
        .label{
            margin-left:25px;
            margin-top: 20px;
            .label-tabs{
                color: #CD6262;
                font-size:12px;
                border: 1px solid #CD6262;
                padding: 4px 8px;
                display: inline-block;
                margin-right: 7px;
            }
        }
    }
    .diagonIsshow{
        position:fixed;
        top:0;
        left: 0;
        width:100%;
        height:100%;
        .bg{
            background:rgba(0,0,0,.35);
            position:fixed;
            top:0;
            left: 0;
            width:100%;
            height:100%;
        }
        .content{
            width:75%;
            background:#fff;
            position: absolute;
            height:300px;
            left:0;
            right:0;
            top:0;
            bottom:0;
            margin: auto;
            .close{
                width:100%;
                height:22px;
                text-align: right;
                img{
                    width:22px;
                    height:100%;
                }
            }
            .diagon-img{
                text-align: center;
                height:87px;
                width: 100%;
                img{
                    height:100%;
                    widows:78px;
                }
            }
            .privacy{
                color:#979797;
                font-size:14px;
                width:156px;
                line-height:20px;
                margin: 0 auto 18px;
                text-align: center;
            }
            .phone{
                color:#353648;
                font-size:26px;
                text-align: center;
                margin-bottom: 33px;
            }
            .link_btn{
                background:#007AFF;
                color:#fff;
                height:50px;
                line-height:50px;
                border-radius:4px;
                width:100%;
                font-size:16px;
                display: block;
                text-align: center;
            }
            .ascription{
                color:#C2C2C2;
                font-size:12px;
                margin-top:8px;
                text-align: center;
            }
        }
    }
    .popupTitle{
        margin: 10px;
        font-size: 16px;
        border-bottom: 1px solid #ccc;
        padding-bottom: 14px;
    }
    .min-title{
        margin: 10px;
        font-size: 14px;
        border-left: 3px solid #0077ff;
        padding-left: 10px;
    }
    .van-radio-group,.van-checkbox-group{
        margin: 20px 10px;
        margin-bottom: 14px;
        ::v-deep .van-radio,.van-checkbox{
            margin-bottom: 10px;
        }
    }
    .van-button{
        margin:8px;
    }
}
</style>